'use client';

import { Button } from '@common/components';

import { INQUIRY_TYPE } from '@/app/donation/constants';
import { DONATION_ROUTES, STORAGE_KEY } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useLoginGuard } from '@/hooks/useLoginGuard';

export const CampaignInquiry = ({
  productNumber,
}: {
  productNumber: string;
}) => {
  const router = useCustomRouter();
  const loginGuard = useLoginGuard();

  return (
    <section className="flex flex-col items-center gap-20 py-60 mobile-tablet:px-20 mobile-tablet:py-40">
      <p className="font-700 text-Gray-900 typo-body1 mobile-tablet:typo-body3">
        상품에 대해 궁금한 것이 있으신가요?
      </p>
      <Button
        theme="sub-line"
        className="w-[375px] mobile-tablet:w-full"
        onClick={() => {
          if (!loginGuard()) {
            return;
          }

          sessionStorage.setItem(
            STORAGE_KEY.IS_DONATION_INQUIRY_BY_GIFT_PRODUCT,
            'true',
          );
          router.push(
            DONATION_ROUTES.MY_INQUIRY_POSTING.withSearchParams({
              dynamicPath: { type: INQUIRY_TYPE.GIFT_PRODUCT },
              searchParams: {
                productNumber,
                redirect: window.location.pathname + window.location.search,
              },
            }),
          );
        }}
      >
        답례품 문의하기
      </Button>
    </section>
  );
};
